
















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { fetchSimSolicitudes } from './fetchSimSolicitudes';
import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '@/config/funcionalidades';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import config from '@/config/index';
import moment from 'moment';

@Component({
  components: {
    DatePicker,
  },
})
export default class ComponenteDialogo extends Vue {
  @Prop({ default: false }) modalContinuar: boolean;
  @Prop({ default: [] }) telcoOptions: any[];

  readonly funcionalidad: Funcionalidades = Funcionalidades.SimSolicitudes;

  usuarioNombre = JSON.parse(localStorage.getItem('user')).nombre;
  usuarioApellido = JSON.parse(localStorage.getItem('user')).apellidoPaterno
    ? JSON.parse(localStorage.getItem('user')).apellidoPaterno
    : '';
  usuario = this.usuarioNombre + ' ' + this.usuarioApellido;
  usuarioID = JSON.parse(localStorage.getItem('user')).id;
  moduloID = this.funcionalidad;
  clienteID = JSON.parse(localStorage.getItem('user')).clienteDefecto;
  telco: any = '';
  plan: any = '';
  destino = 'LABORATORIO';
  fecha = moment();
  estado = '🟢 VIGENTE';

  planOptions: any = [];

  loadingService = new LoadingService();
  dictionaryFormErrors: any = {};
  $snotify: any;

  beforeMount() {
    this.getPlanOptions();
    this.initialize();
  }

  initialize() {
    this.dictionaryFormErrors = {
      custom: {
        telco: {
          required: () => config.errorMensajes.textoRequerido,
        },
        plan: {
          required: () => config.errorMensajes.textoRequerido,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }

  findFilterList({ key }: { key: string }) {
    return this.telcoOptions.filter(x => x[key] !== 't');
  }

  telcoSelected() {
    if (this.telco && this.plan) this.$emit('permitir');
    this.plan = '';
    this.getPlanOptions();
  }

  getPlanOptions() {
    this.loadingService.showLoading(undefined, 'getPlanOptions');
    let fetchBody = {};
    if (this.telco) fetchBody = { telcoid: this.telco.telcoid };
    else fetchBody = { '': '' };

    return fetchSimSolicitudes('getPlan', fetchBody)
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1')
          this.planOptions = data.data.data.LISTA;
        else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.planOptions = [];
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => this.loadingService.hideLoading('getPlanOptions'));
  }

  requiredFields() {
    if (this.telco && this.plan) {
      this.$emit('objCreacion', {
        telcoId: this.telco.telcoid,
        planId: this.plan.telcoplanid,
        destino: this.destino,
        userId: this.usuarioID,
        moduloId: this.moduloID,
        clienteId: this.clienteID,
      });
    }
  }

  get fechaMaxima() {
    const hoy = new Date();
    let fechaMax =
      hoy.getFullYear() +
      '-' +
      this.dosCifras((hoy.getMonth() + 1).toString()) +
      '-' +
      this.dosCifras(hoy.getDate().toString());
    return fechaMax;
  }

  dosCifras(valor: string) {
    return valor.length == 1 ? '0' + valor : valor;
  }
}
